import * as React from "react";
import {Icon, IConcreteIcon} from "../Icon";

export const CashIcon = ({style}: IConcreteIcon) => <Icon file="/icons/payment_methods/cash.svg" style={style} />;
